import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/es/global-this';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import 'core-js/modules/es.function.name.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.regexp.to-string.js';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { __generator, __values, __read, __awaiter, __decorate, __param, __metadata, __asyncValues } from 'tslib';
import 'core-js/modules/es.reflect.to-string-tag.js';
import 'core-js/modules/es.reflect.construct.js';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.dot-all.js';
import 'core-js/modules/es.regexp.sticky.js';
import StackFrame from 'error-stack-parser';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.json.stringify.js';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.array.is-array.js';
import 'core-js/modules/es.object.get-own-property-names.js';
import 'core-js/modules/es.object.get-own-property-descriptor.js';
import 'core-js/modules/es.object.define-property.js';
import { jReport } from '@tencent/docs-scenario-component-j-report';
import { merge } from 'lodash-es';
import 'core-js/modules/es.regexp.test.js';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.parse-int.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.array.find.js';
import 'core-js/modules/es.array.fill.js';
import _typeof from '@babel/runtime/helpers/typeof';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.promise.finally.js';
import { DepGraph } from 'dependency-graph';
import { createDecorator, ServiceRegister, ServiceCollection, InstantiationService } from '@tencent/containerized';
import { trackDisposable, markTracked } from '@tencent/dispose-tree';
import 'core-js/modules/es.symbol.iterator.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.set.js';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'core-js/modules/es.array.last-index-of.js';
import 'core-js/modules/es.array.slice.js';
import { scheduler } from '@tencent/idle-loader';
import { appConfigInstance } from '@tencent/ark-utils/lib/config';
import 'core-js/modules/es.object.values.js';
import 'core-js/modules/es.function.bind.js';
import { IConnectionControllerService, IAccountApplicationService, IEnterpriseAccountApplicationService, IDocsManagementService, ConnectionControllerService, AccountApplicationService, EnterpriseAccountApplicationService, DocsManagementService } from '@tencent/ark-application';
import { IDocMetaDomainService, IUserInfoDomainService, IAuthDomainService, IFileDomainService, ILikeDomainService, IFolderDomainService, ITemplateDomainService, IAccountDomainService, ILoginDomainService, INotificationDomainService, IShareDomainService, IMessageDomainService, ICollaborateDomainService, INotifyScopeDomainService, IAtMessageDomainService, IFileInfoDomainService, IDomainUpdater, DomainUpdater, INetworkRequestService, NetworkRequestService, AuthDomainService, NotificationDomainService, ShareDomainService, CollaborateDomainService, AccountDomainService, IEnterpriseAccountDomainService, EnterpriseAccountDomainService, EnterpriseDocMetaDomainService, DocMetaDomainService, UserInfoDomainService, FileDomainService, FileInfoDomainService, FolderDomainService, TemplateDomainService, LoginDomainService, MessageDomainService, NotifyScopeDomainService, AtMessageDomainService, EnterpriseLikeDomainService, LikeDomainService } from '@tencent/ark-domain';
import { networkRequest } from '@tencent/ark-request';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'core-js/modules/es.global-this.js';
import 'core-js/modules/es.array.reduce.js';
import _get from '@babel/runtime/helpers/get';
import 'core-js/modules/web.timers.js';

/**
 * 手动加一个 performance.now 的 polyfill，防止浏览器不存在这个方法
 */
if (!('performance' in window)) {
  window.performance = {};
}
Date.now = Date.now || function () {
  return Date.now();
};
if (!('now' in window.performance)) {
  var nowOffset = Date.now();
  if (performance.timing && performance.timing.navigationStart) {
    nowOffset = performance.timing.navigationStart;
  }
  window.performance.now = function now() {
    return Date.now() - nowOffset;
  };
}

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ExtensionError = /*#__PURE__*/function (_Error) {
  _inherits(ExtensionError, _Error);
  var _super = _createSuper$7(ExtensionError);
  function ExtensionError(message) {
    _classCallCheck(this, ExtensionError);
    var messageWithPrefix = "(Extension Error) ".concat(message);
    return _super.call(this, messageWithPrefix);
  }
  return _createClass(ExtensionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/** 自定义事件名 */
var CustomEventName;
(function (CustomEventName) {
  CustomEventName["FunctionCallCostTime"] = "\u7EC4\u4EF6\u65B9\u6CD5\u6267\u884C\u8017\u65F6";
  CustomEventName["FunctionCallError"] = "\u7EC4\u4EF6\u65B9\u6CD5\u6267\u884C\u9519\u8BEF";
  CustomEventName["GlobalFunctionCallError"] = "\u6F0F\u5230\u5168\u5C40\u7684\u7EC4\u4EF6\u65B9\u6CD5\u6267\u884C\u9519\u8BEF";
  CustomEventName["LoadCostTime"] = "\u7EC4\u4EF6\u8D44\u6E90\u52A0\u8F7D\u8017\u65F6";
  CustomEventName["LoadFailed"] = "\u7EC4\u4EF6\u8D44\u6E90\u52A0\u8F7D\u5931\u8D25";
})(CustomEventName || (CustomEventName = {}));

/**
 * 自定义事件派发器，解耦了具体的上报逻辑。
 */
var CustomReportEventDispatcher = /*#__PURE__*/function () {
  function CustomReportEventDispatcher() {
    _classCallCheck(this, CustomReportEventDispatcher);
  }
  _createClass(CustomReportEventDispatcher, null, [{
    key: "loadCost",
    value:
    /**
     * 派发模块加载耗时事件
     */
    function loadCost(detail) {
      var event = new CustomEvent(CustomEventName.LoadCostTime, {
        detail: detail
      });
      window.dispatchEvent(event);
    }
    /**
     * 派发模块加载失败事件
     */
  }, {
    key: "loadFail",
    value: function loadFail(detail) {
      var event = new CustomEvent(CustomEventName.LoadFailed, {
        detail: detail
      });
      window.dispatchEvent(event);
    }
    /**
     * 派发方法调用耗时事件
     */
  }, {
    key: "functionCallCost",
    value: function functionCallCost(detail) {
      var event = new CustomEvent(CustomEventName.FunctionCallCostTime, {
        detail: detail
      });
      window.dispatchEvent(event);
    }
    /**
     * 派发方法调用出错事件
     */
  }, {
    key: "functionCallError",
    value: function functionCallError(detail) {
      var event = new CustomEvent(CustomEventName.FunctionCallError, {
        detail: detail
      });
      window.dispatchEvent(event);
    }
  }]);
  return CustomReportEventDispatcher;
}();

// compatible with global
// 目前浏览器环境、Jest环境(jsDom)都有global
// node环境先简单mock一下。   后续补齐 or 是不是node环境也jsDom处理一下呢？
var MOCK_GLOBAL = {};
function isInBrowser() {
  return typeof window !== 'undefined';
}
function isInNodeJS() {
  return typeof global !== 'undefined';
}
function isInWebWorker() {
  return !isInBrowser && typeof self !== 'undefined';
}
function isInJestEnv() {
  return isInNodeJS() && typeof global.describe === 'function';
}
/**
 * 获取全局变量
 */
function getGlobalObject() {
  if (isInBrowser()) {
    return window;
  }
  if (isInNodeJS()) {
    return global;
  }
  if (isInWebWorker()) {
    return self;
  }
  if (isInJestEnv()) {
    return MOCK_GLOBAL;
  }
  return MOCK_GLOBAL;
}
var browserUtilsGlobal = getGlobalObject();
var global$1 = browserUtilsGlobal;

/**
 * 判断Object是否有key属性
 * @category Object
 * @param {obj} 被判断的对象
 * @param {key} 要检查的key属性名
 * @returns {boolean} true: 表示属性存在; false: 属性不存在
 */
function has(obj, key) {
  return obj !== null && Object.prototype.hasOwnProperty.call(obj, key);
}

// document 属性名
var DOCUMENT_PREPROTY = 'document';
/**
 * ark 目前支持的常用cookie字段集合。
 * 建议不要直接使用setCookie和getCookie
 */
var COMMON_COOKIES_KEYS;
(function (COMMON_COOKIES_KEYS) {
  /**
   * cgi相关 xsrf token
   */
  COMMON_COOKIES_KEYS["xsrf"] = "TOK";
  /**
   * 测试环境相关   测试环境routeId
   */
  COMMON_COOKIES_KEYS["devRouteId"] = "dev_route_id";
  /**
   * 测试环境相关   测试环境登录账号名
   */
  COMMON_COOKIES_KEYS["devOaName"] = "dev_oa_name";
  /**
   * 测试环境相关   测试环境FD
   */
  COMMON_COOKIES_KEYS["fd"] = "fd";
  /**
   * 测试环境相关   env_id 后期epc统计相关字段
   */
  COMMON_COOKIES_KEYS["envId"] = "env_id";
  /**
   * 登录态相关
   * 登录态判断和取当前登录用户信息不要直接用Cookie判断
   * 取UserInfoDomainService的isLogin来判断是否登录
   * uid 取UserInfoDomainService里UserInfo.tinyid
   */
  /**
   * 登录态相关   多登录态SID
   */
  COMMON_COOKIES_KEYS["sid"] = "SID";
  /**
   * 登录态相关   多登录态SIDS
   */
  COMMON_COOKIES_KEYS["sids"] = "SID_S";
  /**
   * 登录态相关   uid
   */
  COMMON_COOKIES_KEYS["uid"] = "uid";
  /**
   * 登录态相关   uid_key
   */
  COMMON_COOKIES_KEYS["uidKey"] = "uid_key";
  /**
   * 登录态相关   uin QQ号
   */
  COMMON_COOKIES_KEYS["uin"] = "uin";
  /**
   * 登录态相关   登录时间
   */
  COMMON_COOKIES_KEYS["loginTime"] = "loginTime";
  /**
   * 登录态相关   是否已登录
   */
  COMMON_COOKIES_KEYS["hasBeenLogin"] = "has_been_login";
  /**
   * 其它   渠道号
   */
  COMMON_COOKIES_KEYS["adtag"] = "adtag";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["plUin"] = "p_luin";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["pUin"] = "p_uin";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["pSkey"] = "p_skey";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["plSkey"] = "p_lskey";
})(COMMON_COOKIES_KEYS || (COMMON_COOKIES_KEYS = {}));
/**
 * get cookie
 * @param  {string} key [key]
 * @return {string}     [cookie value]
 */
function getCookie(key) {
  if (!has(global$1, DOCUMENT_PREPROTY)) {
    // node环境目前简单处理，后续需要mock再处理；
    return null;
  }
  var reg = new RegExp("(?:^|;+|\\s+)".concat(key, "=([^;]*)"));
  var result = document.cookie.match(reg);
  return (!result ? null : result[1]) || null;
}

/** 从环境中获取 User Agent. */
var getUserAgent = /* #__PURE__ */function () {
  var userAgent;
  return function () {
    // 服务端渲染不会提供 window，会提供 global 供兼容 - sigma
    if (userAgent === undefined) {
      userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    }
    return userAgent;
  };
}();
// 下面一系列函数将第一个参数是 userAgent 的函数, 转换为支持自动获取的, 并将 userAgent 移到末尾.
// 这种固定参数的写法在运行时速度最快, 包体积最小, 但是有一些魔法和类型体操, 不懂勿改.
function withDefaultUA(fn) {
  return function (userAgent) {
    return fn(userAgent || getUserAgent());
  };
}

/** *******************************************************************************
 * 一、硬件级别判断
 *********************************************************************************/
/**
 * 是否是移动端, iPad 和 Android Pad 和 Harmony Pad 包含在移动端
 */
var isMobile = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /(mobile)/i.test(userAgent) || isAndroidPad(userAgent) || isHarmonyPad(userAgent);
});
/**
 * 是否是 iPad
 */
var isIPad = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /(ipad)/i.test(userAgent);
});
/**
 * 是否是 Android 平板
 */
var isAndroidPad = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return (!/(mobile)/i.test(userAgent) || /(tdocsIsPad)/i.test(userAgent)) && isAndroid(userAgent);
});
/**
 * 是否是 Harmony 平板
 */
var isHarmonyPad = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return isHarmony(userAgent) && !/mobile/i.test(userAgent);
});
/**
 * 是否是 PC 或 Mac 设备
 */
var isPC = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return !isMobile(userAgent);
});
/** *******************************************************************************
 * 二、操作系统级别判断
 *********************************************************************************/
/**
 * 是否是 Android 平台
 */
var isAndroid = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /android|adr/i.test(userAgent);
});
/**
 * 是否是 Harmony 平台
 */
var isHarmony = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /OpenHarmony/i.test(userAgent);
});
/** *******************************************************************************
 * 三、浏览器/浏览器内核级别判断
 *********************************************************************************/
/**
 * 是不是 PC 上的 QQ 浏览器
 * 会自动排除 PC QQ
 */
var isPCQQBrowser = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return !isMobile(userAgent) && /QQBrowser/i.test(userAgent)
  // 排除 PC QQ
  && !/QBCore/i.test(userAgent);
});
/**
 * 是不是移动端上的 QQ 浏览器
 * 会自动排除 QQ / TIM / 微信 / 企业微信 / 独立 App / 腾讯会议
 */
var isMobileQQBrowser = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return isMobile(userAgent) && /MQQBrowser/i.test(userAgent) && !isTimOrQQ(userAgent) && !isWeChat(userAgent) && !isWxWork(userAgent) && !isTencentDocsApp(userAgent) && !isWeiYunApp(userAgent) && !isMiniProgram(userAgent) && !isTencentMeeting(userAgent);
});
/**
 * 是否是 QQ 浏览器
 */
var isQQBrowser = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return isMobile(userAgent) ? isMobileQQBrowser(userAgent) : isPCQQBrowser(userAgent);
});
/**
 * 是否是 Chrome 浏览器
 */
var isChrome = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /(Chrome|CriOS)\/\S+( Mobile\S*)? Safari\/\S+$/i.test(userAgent);
});
/**
 * 是否是 Safari 浏览器
 */
var isSafari = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /Version\/\S+( Mobile\S*)? Safari\/\S+$/i.test(userAgent);
});
/**
 * 是否是 IE 浏览器
 */
var isIE = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /MSIE/i.test(userAgent) && !/opera/i.test(userAgent) || /Trident/i.test(userAgent);
});
/**
 * 是否是新版 Chromium Edge 浏览器
 */
var isChromiumEdge = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /Edg\//i.test(userAgent);
});
/** *******************************************************************************
 * 四、微信/企业微信 H5 判断
 *********************************************************************************/
/**
 * 是否是微信 H5
 * 自动排除企业微信和微信小程序
 */
var isWeChat = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /MicroMessenger/i.test(userAgent) && !isWxWork(userAgent) && !isWxMiniProgram(userAgent);
});
/**
 * 是否是企业微信
 * 注意：包含企业微信小程序
 */
var isWxWork = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /(wxwork)/i.test(userAgent);
});
/** *******************************************************************************
 * 五、QQ/TIM H5 判断
 *********************************************************************************/
/**
 * 是否是 QQ H5
 * 会自动排除文档独立 App / 企业微信 / 微信 / QQ 浏览器 / TIM
 */
var isQQ = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /QQ\//i.test(userAgent) && !isTencentDocsApp(userAgent) && !isQQMiniProgram(userAgent) && !isTim(userAgent);
});
/**
 * 是否是 TIM
 * 注意：包含 TIM 小程序
 */
var isTim = /* #__PURE__ */withDefaultUA(function (userAgent) {
  // 手机 TIM 4.0 新版本 UA 为 MIT
  return /(TIM|MIT)\//i.test(userAgent);
});
/**
 * 是否是 TIM 或者 QQ H5
 * 注意：不包含 QQ/TIM 小程序
 */
var isTimOrQQ = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return isTim(userAgent) && !isQQMiniProgram(userAgent) || isQQ(userAgent);
});
/**
 * 是否在 QQ mini 端（QQ 预览文档平台，可以理解为 QQ 桌面端内嵌的文档客户端）
 */
var isQQDesktopDocsClient = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /QQEX/i.test(userAgent) && isElectronTencentDocsClient(userAgent);
});
/** *******************************************************************************
 * 六、小程序（webview/原生）判断
 *********************************************************************************/
/**
 * 是否是（微信/企业微信或 QQ/TIM）的小程序 webview
 */
var isMiniProgram = /* #__PURE__ */withDefaultUA(function (userAgent) {
  // 企业微信 iOS 比较特殊，UA 中没有小程序的字样，只能通过全局 __wxjs_environment 来判断
  return /miniprogram|miniapp(?!enable)/i.test(userAgent)
  // eslint-disable-next-line camelcase
  || typeof __wxjs_environment !== 'undefined' && __wxjs_environment === 'miniprogram';
});
/**
 * 是否是微信/企业微信小程序 webview
 */
var isWxMiniProgram = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /MicroMessenger/i.test(userAgent) && isMiniProgram(userAgent);
});
/**
 * 是否是 QQ/TIM 小程序 webview
 */
var isQQMiniProgram = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /QQ\/|TIM/i.test(userAgent) && isMiniProgram(userAgent);
});
/** *******************************************************************************
 * 七、独立 App 判断
 *********************************************************************************/
/**
 * 是否是移动客户端
 */
var isTencentDocsApp = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /TencentDocs/i.test(userAgent);
});
/**
 * 是否是 Electron 客户端
 */
var isElectronTencentDocsClient = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /TDAppDesktop/i.test(userAgent);
});
/**
 * 是否是微云 App
 */
var isWeiYunApp = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /weiyun/i.test(userAgent);
});
/**
 * 是否是腾讯会议
 */
var isTencentMeeting = /* #__PURE__ */withDefaultUA(function (userAgent) {
  return /tencent_wemeet/i.test(userAgent);
});

var isPCDevice = isPC();
var isMobileDevice = isMobile();
var isPadDevice = isAndroidPad() || isIPad() || isHarmonyPad();
/**
 * 设备类型，目前只区分常用的 3 大种类。
 */
function getDeviceType() {
  if (isPCDevice) return 'pc';
  if (isMobileDevice) return 'mobile';
  if (isPadDevice) return 'pad';
  return 'unknown_device';
}

var map = {
  // 司内应用载体
  wechat_mini_program: isWxMiniProgram(),
  qq_mini_program: isQQMiniProgram(),
  mobile_app: isTencentDocsApp(),
  desktop_client: isElectronTencentDocsClient(),
  meeting: isTencentMeeting(),
  qq_internal_client: isQQDesktopDocsClient(),
  qq_browser: isQQBrowser(),
  wechat_h5: isWeChat(),
  qq_h5: isQQ(),
  // 第三方常见载体
  chrome: isChrome(),
  safari: isSafari(),
  edge: isChromiumEdge(),
  ie: isIE()
};
var keyNames = Object.keys(map);
/**
 * 承载文档页面的应用容器的类型。
 */
function getWebPageHostContainer() {
  return keyNames.find(function (key) {
    return map[key];
  }) || 'others';
}

var _a, _b;
var isProduction = function isProduction() {
  var _a;
  return !((_a = getCookie('env_id')) === null || _a === void 0 ? void 0 : _a.includes('sit'));
};
var SDK_TOKEN = 'SDK-b99328fe37901c8f78c5';
var DEFAULT_CONFIG = {
  token: SDK_TOKEN,
  env: isProduction() ? 'production' : 'test',
  level: 'info',
  type: 'normal',
  uid: ((_b = (_a = window.basicClientVars) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.tinyId) || ''
};
var GalileoReporter = /*#__PURE__*/function () {
  function GalileoReporter() {
    _classCallCheck(this, GalileoReporter);
  }
  _createClass(GalileoReporter, [{
    key: "info",
    value: function info(data) {
      var customData = data.customData,
        module = data.module;
      var params = merge({}, DEFAULT_CONFIG, {
        type: 'custom_event',
        customData: Object.assign(Object.assign({}, getCommonCustomData()), customData),
        extField: {
          ext1: module
        }
      });
      jReport(params);
    }
  }, {
    key: "error",
    value: function error(data) {
      var customData = data.customData,
        module = data.module;
      var params = merge({}, DEFAULT_CONFIG, {
        type: 'custom_event',
        level: 'error',
        customData: Object.assign(Object.assign({}, getCommonCustomData()), customData),
        extField: {
          ext1: module
        }
      });
      jReport(params);
    }
  }]);
  return GalileoReporter;
}();
/**
 * 获取通用的自定义数据字段。
 */
function getCommonCustomData() {
  var _a, _b;
  // 短期内成本较低的 padId 和 padType 获取方式。
  // TODO: 后续需要先对 ark-extensions 进行一定改造方可优雅地拿到这俩字段
  var _ref = ((_b = (_a = window.basicClientVars) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) || {},
    _ref$padId = _ref.padId,
    padId = _ref$padId === void 0 ? 'unknown' : _ref$padId,
    _ref$padType = _ref.padType,
    padType = _ref$padType === void 0 ? 'unknown' : _ref$padType;
  return {
    padId: padId,
    padType: padType,
    deviceType: getDeviceType(),
    webPageHostContainer: getWebPageHostContainer()
  };
}
var galileoReporter = new GalileoReporter();

var INIT_REPORTER_HANDLER = '__ark_extension_init_reporter_handler__';
/**
 * 初始化上报事件总线。
 */
function initReporters() {
  if (window[INIT_REPORTER_HANDLER]) {
    return;
  }
  window[INIT_REPORTER_HANDLER] = true;
  // 资源加载耗时事件监听
  window.addEventListener(CustomEventName.LoadCostTime, function (e) {
    var _a, _b;
    var detail = e.detail;
    var module = detail.module,
      _detail$duration = detail.duration,
      duration = _detail$duration === void 0 ? -1 : _detail$duration,
      _detail$url = detail.url,
      url = _detail$url === void 0 ? '' : _detail$url;
    // 暂时只匹配这几种格式的静态资源
    var regex = /^.*\.(js|css)$/;
    galileoReporter.info({
      customData: {
        eventName: CustomEventName.LoadCostTime,
        duration: duration,
        url: url,
        fileExtension: (_b = (_a = regex.exec(url)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : 'unknown'
      },
      module: module
    });
  });
  // 资源加载失败事件监听
  window.addEventListener(CustomEventName.LoadFailed, function (e) {
    var detail = e.detail;
    var module = detail.module,
      _detail$duration2 = detail.duration,
      duration = _detail$duration2 === void 0 ? -1 : _detail$duration2,
      _detail$url2 = detail.url,
      url = _detail$url2 === void 0 ? '' : _detail$url2,
      error = detail.error;
    var _extractErrorDetail = extractErrorDetail(error),
      errorMessage = _extractErrorDetail.errorMessage,
      errorStack = _extractErrorDetail.errorStack;
    galileoReporter.error({
      customData: {
        eventName: CustomEventName.LoadFailed,
        duration: duration,
        url: url,
        errorMessage: errorMessage,
        errorStack: errorStack
      },
      module: module
    });
  });
  // 方法调用耗时事件监听
  window.addEventListener(CustomEventName.FunctionCallCostTime, function (e) {
    var detail = e.detail;
    var _detail$duration3 = detail.duration,
      duration = _detail$duration3 === void 0 ? -1 : _detail$duration3,
      functionName = detail.functionName,
      module = detail.module;
    // 忽略小于 800 ms 的方法调用,
    if (typeof duration === 'number' && duration < 800) {
      return;
    }
    galileoReporter.info({
      customData: {
        eventName: CustomEventName.FunctionCallCostTime,
        functionName: functionName,
        duration: duration
      },
      module: module
    });
  });
  // （组件）方法调用错误事件监听
  window.addEventListener(CustomEventName.FunctionCallError, function (e) {
    var detail = e.detail;
    var error = detail.error,
      functionName = detail.functionName,
      module = detail.module;
    var _extractErrorDetail2 = extractErrorDetail(error),
      errorMessage = _extractErrorDetail2.errorMessage,
      errorStack = _extractErrorDetail2.errorStack;
    galileoReporter.error({
      customData: {
        eventName: CustomEventName.FunctionCallError,
        functionName: functionName,
        errorMessage: errorMessage,
        errorStack: errorStack
      },
      module: module
    });
  });
  // （全局）方法调用错误事件监听
  window.addEventListener('error', function (e) {
    if (!((e === null || e === void 0 ? void 0 : e.error) instanceof Error)) {
      return;
    }
    var stack = StackFrame.parse(e.error);
    var componentStack = [];
    stack.forEach(function (e) {
      if (!e.fileName) {
        return;
      }
      var name = parseUrl(e.fileName);
      if (name) {
        componentStack.push(name);
      }
    });
    if (componentStack.length === 0) {
      return;
    }
    var module = componentStack[componentStack.length - 1];
    var _extractErrorDetail3 = extractErrorDetail(e.error),
      errorMessage = _extractErrorDetail3.errorMessage,
      errorStack = _extractErrorDetail3.errorStack;
    galileoReporter.error({
      customData: {
        eventName: CustomEventName.GlobalFunctionCallError,
        errorMessage: errorMessage,
        errorStack: errorStack
      },
      module: module
    });
  });
}
/**
 * 解析调用栈的 url 是否为 dc 组件
 */
function parseUrl(url) {
  var regex = new RegExp(/(docs-component-.*)\..*\.js$/);
  var match = regex.exec(url);
  if (match === null || match === void 0 ? void 0 : match[1]) {
    return match[1];
  }
  return undefined;
}
/**
 * 从一个错误对象当中提取关键的错误详情，返回错误信息和错误堆栈信息。
 */
function extractErrorDetail(error) {
  return {
    errorMessage: (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.toString()),
    errorStack: (error === null || error === void 0 ? void 0 : error.stack) || (error === null || error === void 0 ? void 0 : error.toString())
  };
}

/**
 * 代理 DC 实例，上报方法调用耗时
 * 只上报异步调用的耗时（一般同步方法耗时可以忽略不计）
 */
function proxyToReport(instance, module, url) {
  if (_typeof(instance) !== 'object') {
    return instance;
  }
  return new Proxy(instance, {
    get: function get(target, functionName) {
      var value = target[functionName];
      if (typeof value !== 'function') {
        return value;
      }
      return function proxy() {
        var start = performance.now();
        var reportCost = function reportCost() {
          var duration = Math.floor(performance.now() - start);
          CustomReportEventDispatcher.functionCallCost({
            module: module,
            functionName: functionName,
            duration: duration,
            url: url,
            start: start
          });
        };
        var reportError = function reportError(err) {
          var duration = Math.floor(performance.now() - start);
          CustomReportEventDispatcher.functionCallError({
            module: module,
            functionName: functionName,
            duration: duration,
            url: url,
            error: err,
            start: start
          });
        };
        var result;
        try {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          // 尝试同步调用函数
          result = value.call.apply(value, [this].concat(args));
        } catch (err) {
          // 同步异常捕获
          reportError(err);
          // 继续向上抛出异常
          throw err;
        }
        // 根据返回结果类型进行处理
        if (result instanceof Promise) {
          // 异步调用
          result["finally"](reportCost)["catch"](reportError);
        }
        return result;
      };
    }
  });
}

var IMetadataLoader = createDecorator('IMetadataLoader');

var Node = /** @class */function () {
  function Node(element) {
    this.element = element;
    this.next = Node.Undefined;
    this.prev = Node.Undefined;
  }
  Node.Undefined = new Node(undefined);
  return Node;
}();
var LinkedList = /** @class */function () {
  function LinkedList() {
    this.first = Node.Undefined;
    this.last = Node.Undefined;
    this.mSize = 0;
  }
  Object.defineProperty(LinkedList.prototype, "size", {
    get: function get() {
      return this.mSize;
    },
    enumerable: false,
    configurable: true
  });
  LinkedList.prototype.isEmpty = function () {
    return this.first === Node.Undefined;
  };
  LinkedList.prototype.clear = function () {
    this.first = Node.Undefined;
    this.last = Node.Undefined;
    this.mSize = 0;
  };
  LinkedList.prototype.unshift = function (element) {
    return this.insert(element, false);
  };
  LinkedList.prototype.push = function (element) {
    return this.insert(element, true);
  };
  LinkedList.prototype.shift = function () {
    if (this.first === Node.Undefined) {
      return undefined;
    }
    var res = this.first.element;
    this.remove(this.first);
    return res;
  };
  LinkedList.prototype.pop = function () {
    if (this.last === Node.Undefined) {
      return undefined;
    }
    var res = this.last.element;
    this.remove(this.last);
    return res;
  };
  LinkedList.prototype[Symbol.iterator] = function () {
    var node;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          node = this.first;
          _a.label = 1;
        case 1:
          if (!(node !== Node.Undefined)) return [3 /*break*/, 3];
          return [4 /*yield*/, node.element];
        case 2:
          _a.sent();
          node = node.next;
          return [3 /*break*/, 1];
        case 3:
          return [2 /*return*/];
      }
    });
  };

  LinkedList.prototype.insert = function (element, atTheEnd) {
    var _this = this;
    var newNode = new Node(element);
    if (this.first === Node.Undefined) {
      this.first = newNode;
      this.last = newNode;
    } else if (atTheEnd) {
      // push
      var oldLast = this.last;
      this.last = newNode;
      newNode.prev = oldLast;
      oldLast.next = newNode;
    } else {
      // unshift
      var oldFirst = this.first;
      this.first = newNode;
      newNode.next = oldFirst;
      oldFirst.prev = newNode;
    }
    this.mSize += 1;
    var didRemove = false;
    return function () {
      if (!didRemove) {
        didRemove = true;
        _this.remove(newNode);
      }
    };
  };
  LinkedList.prototype.remove = function (node) {
    if (node.prev !== Node.Undefined && node.next !== Node.Undefined) {
      // middle
      var anchor = node.prev;
      anchor.next = node.next;
      node.next.prev = anchor;
      node.next = Node.Undefined;
      node.prev = Node.Undefined;
    } else if (node.prev === Node.Undefined && node.next === Node.Undefined) {
      // only node
      this.first = Node.Undefined;
      this.last = Node.Undefined;
    } else if (node.next === Node.Undefined) {
      // last
      this.last = this.last.prev;
      this.last.next = Node.Undefined;
      node.prev = Node.Undefined;
    } else if (node.prev === Node.Undefined) {
      // first
      this.first = this.first.next;
      this.first.prev = Node.Undefined;
      node.next = Node.Undefined;
    }
    // done
    this.mSize -= 1;
  };
  return LinkedList;
}();

var Emitter = /** @class */function () {
  function Emitter(options) {
    this.disposed = false;
    this.options = options;
  }
  Object.defineProperty(Emitter.prototype, "event", {
    /**
       * 可用于订阅该 Emitter 的事件
       */
    get: function get() {
      var _this = this;
      if (!this.mEvent) {
        this.mEvent = function (listener, thisArgs, disposables) {
          var _a, _b, _c;
          if (!_this.listeners) {
            _this.listeners = new LinkedList();
          }
          var firstListener = _this.listeners.isEmpty();
          if (firstListener && ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.onFirstListenerAdd)) {
            _this.options.onFirstListenerAdd(_this);
          }
          var remove = _this.listeners.push(!thisArgs ? listener : [listener, thisArgs]);
          if (firstListener && ((_b = _this.options) === null || _b === void 0 ? void 0 : _b.onFirstListenerDidAdd)) {
            _this.options.onFirstListenerDidAdd(_this);
          }
          if ((_c = _this.options) === null || _c === void 0 ? void 0 : _c.onListenerDidAdd) {
            _this.options.onListenerDidAdd(_this, listener, thisArgs);
          }
          var result = {
            dispose: function dispose() {
              var _a;
              if (!_this.disposed) {
                remove();
                if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.onLastListenerRemove) {
                  var hasListeners = _this.listeners && !_this.listeners.isEmpty();
                  if (!hasListeners) {
                    _this.options.onLastListenerRemove(_this);
                  }
                }
              }
              markTracked(result);
            },
            disposableId: 'event'
          };
          if (Array.isArray(disposables)) {
            disposables.push(result);
          }
          trackDisposable(result);
          return result;
        };
      }
      return this.mEvent;
    },
    enumerable: false,
    configurable: true
  });
  /**
     * To be kept private to fire an event to
     * subscribers
     */
  Emitter.prototype.fire = function (event) {
    var e_1, _a;
    if (this.listeners) {
      // put all [listener,event]-pairs into delivery queue
      // then emit all event. an inner/nested event might be
      // the driver of this
      if (!this.deliveryQueue) {
        this.deliveryQueue = new LinkedList();
      }
      try {
        for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
          var listener = _c.value;
          this.deliveryQueue.push([listener, event]);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      while (this.deliveryQueue.size > 0) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var _d = __read(this.deliveryQueue.shift(), 2),
          listener = _d[0],
          event_1 = _d[1];
        try {
          if (typeof listener === 'function') {
            listener.call(undefined, event_1);
          } else {
            listener[0].call(listener[1], event_1);
          }
        } catch (e) {
          console.error(e);
        }
      }
    }
  };
  Emitter.prototype.dispose = function () {
    if (this.listeners) {
      this.listeners.clear();
    }
    if (this.deliveryQueue) {
      this.deliveryQueue.clear();
    }
    this.disposed = true;
  };
  return Emitter;
}();

var ScheduleLoaderHookName;
(function (ScheduleLoaderHookName) {
  ScheduleLoaderHookName["LOADING"] = "LOADING";
  ScheduleLoaderHookName["LOADED"] = "LOADED";
  ScheduleLoaderHookName["ERROR"] = "ERROR";
})(ScheduleLoaderHookName || (ScheduleLoaderHookName = {}));
/**
 * 加载时机，它们的 key 表示时机的种类，值表示优先级
 * ON_DEMAND：调用时加载
 * IDLE：闲时加载
 * EAGER：立即加载
 */
var LoadType;
(function (LoadType) {
  LoadType[LoadType["IDLE"] = 1] = "IDLE";
  LoadType[LoadType["ON_DEMAND"] = 3] = "ON_DEMAND";
  LoadType[LoadType["EAGER"] = 7] = "EAGER";
})(LoadType || (LoadType = {}));
var LoadState;
(function (LoadState) {
  LoadState["WAITING"] = "waiting";
  LoadState["LOADING"] = "loading";
  LoadState["ERROR"] = "error";
  LoadState["SUCCESS"] = "success";
})(LoadState || (LoadState = {}));

var ScriptLoader = /*#__PURE__*/function () {
  function ScriptLoader() {
    _classCallCheck(this, ScriptLoader);
    this.loadCache = new Map();
    this.retryCountMap = new Map();
  }
  _createClass(ScriptLoader, [{
    key: "loadScript",
    value: function loadScript(entryName, scriptUrl, retryCount, isCss) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defferedModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 从loadCache拿到已经触发加载的Promise
              defferedModule = this.loadCache.get(scriptUrl);
              if (defferedModule) {
                _context.next = 7;
                break;
              }
              this.setRetryCount(entryName, retryCount);
              _context.next = 5;
              return this.defferedLoadModule(entryName, scriptUrl, isCss);
            case 5:
              defferedModule = _context.sent;
              this.loadCache.set(scriptUrl, defferedModule);
            case 7:
              return _context.abrupt("return", defferedModule);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setRetryCount",
    value: function setRetryCount(entryName, retryCount) {
      this.retryCountMap.set(entryName, retryCount);
    }
    /**
     * @param entryName
     * @param scriptUrl
     */
  }, {
    key: "defferedLoadModule",
    value: function defferedLoadModule(entryName, scriptUrl, isCss) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var data = {
                  entryName: entryName,
                  scriptUrl: scriptUrl,
                  isCss: isCss,
                  curRetryCount: 1,
                  succCallback: resolve,
                  failedCallback: reject
                };
                _this.loadInBrowser(data);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }, {
    key: "loadInBrowser",
    value: function loadInBrowser(props) {
      var _this2 = this;
      var _a;
      var entryName = props.entryName,
        scriptUrl = props.scriptUrl,
        isCss = props.isCss,
        curRetryCount = props.curRetryCount,
        succCallback = props.succCallback,
        failedCallback = props.failedCallback;
      var start = performance.now();
      var regexpMatchExtensionName = /docs-component-[^\s.]+/;
      var extensionName = ((_a = regexpMatchExtensionName.exec(entryName)) === null || _a === void 0 ? void 0 : _a[0]) || "unknown-".concat(entryName);
      var onScriptLoadSuccess = function onScriptLoadSuccess() {
        var duration = Math.floor(performance.now() - start);
        CustomReportEventDispatcher.loadCost({
          module: extensionName,
          url: scriptUrl,
          duration: duration,
          start: start
        });
        var module = global[entryName];
        if (module === null || module === void 0 ? void 0 : module["default"]) {
          succCallback(module["default"]);
          return;
        }
        succCallback(module !== null && module !== void 0 ? module : {});
      };
      var onScriptLoadFail = function onScriptLoadFail() {
        var retryCount = _this2.retryCountMap.get(entryName) || 0;
        var duration = Math.floor(performance.now() - start);
        CustomReportEventDispatcher.loadFail({
          module: extensionName,
          url: scriptUrl,
          error: new Error("retryCount:".concat(retryCount)),
          duration: duration,
          start: start
        });
        if (curRetryCount > retryCount) {
          failedCallback("failed to load module [".concat(entryName, "] after [").concat(curRetryCount - 1, "] retry times."));
          return;
        }
        // 出错时的重试逻辑
        // 移除出错的script标签
        // 此处回调函数和 script 标签间的确存在相互依赖关系
        // 可能已经被其他插件移除，例如 alloy-cdn-retry, 加个判断，防止抛出异常导致 组件拉起失败
        if (script.parentElement) {
          document.head.removeChild(script);
        }
        var data = {
          entryName: entryName,
          scriptUrl: scriptUrl,
          isCss: isCss,
          curRetryCount: curRetryCount + 1,
          succCallback: succCallback,
          failedCallback: failedCallback
        };
        // 重新触发加载，递归调用
        _this2.loadInBrowser(data);
      };
      // css 与 js 的使用不同标签加载
      var tag = isCss ? this.buildLinkTag : this.buildScriptTag;
      var script = tag(scriptUrl, onScriptLoadSuccess, onScriptLoadFail);
      document.head.appendChild(script);
    }
  }, {
    key: "buildLinkTag",
    value: function buildLinkTag(url, onLoad, onError) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.onload = onLoad;
      link.onerror = onError;
      return link;
    }
  }, {
    key: "buildScriptTag",
    value: function buildScriptTag(url, onLoad, onError) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      // 确保script按插入<script>标签的顺序执行
      script.async = false;
      // 兼容本地加载，如果是http/https加载，才设置crossOrigin
      var protocol = window.location.protocol;
      if (protocol === 'http:' || protocol === 'https:') {
        script.crossOrigin = 'anonymous';
      }
      script.onload = onLoad;
      script.onerror = onError;
      return script;
    }
  }]);
  return ScriptLoader;
}();

var scriptLoader = new ScriptLoader();

var ScheduleLoader = /*#__PURE__*/function () {
  function ScheduleLoader(entryName, resourceUrl, options) {
    _classCallCheck(this, ScheduleLoader);
    var _a, _b;
    this.hookEmitter = new Emitter();
    this.loadState = LoadState.WAITING;
    this.entryName = entryName;
    this.resourceUrl = resourceUrl;
    this.options = options;
    this.retryTimes = (_a = options === null || options === void 0 ? void 0 : options.retryTimes) !== null && _a !== void 0 ? _a : ScheduleLoader.defaultRetryTimes;
    this.isCss = (_b = options === null || options === void 0 ? void 0 : options.isCss) !== null && _b !== void 0 ? _b : false;
    this.setupHooks();
  }
  _createClass(ScheduleLoader, [{
    key: "loadModule",
    value: function loadModule() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var module;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 标记加载过程的开始
              this.loadState = LoadState.LOADING;
              this.hookEmitter.fire(ScheduleLoaderHookName.LOADING);
              // 开始加载 module
              _context.prev = 2;
              _context.next = 5;
              return ScheduleLoader.scriptLoader.loadScript(this.entryName, this.resourceUrl, this.retryTimes, this.isCss);
            case 5:
              module = _context.sent;
              // 标记该加载过程成功
              this.loadState = LoadState.SUCCESS;
              this.hookEmitter.fire(ScheduleLoaderHookName.LOADED);
              return _context.abrupt("return", module);
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              // 标记该加载过程失败
              this.loadState = LoadState.ERROR;
              this.hookEmitter.fire(ScheduleLoaderHookName.ERROR);
              throw _context.t0;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 11]]);
      }));
    }
  }, {
    key: "setupHooks",
    value: function setupHooks() {
      var _this = this;
      this.hookEmitter.event(function (name) {
        var _a, _b;
        var handler = (_b = (_a = _this.options) === null || _a === void 0 ? void 0 : _a.hooks) === null || _b === void 0 ? void 0 : _b[name];
        if (handler) {
          handler();
        }
      });
    }
  }]);
  return ScheduleLoader;
}();
ScheduleLoader.defaultRetryTimes = 2;
ScheduleLoader.scriptLoader = scriptLoader;

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 加载策略: 立即加载
 * （构造时加载）
 */
var EagerLoader = /*#__PURE__*/function (_ScheduleLoader) {
  _inherits(EagerLoader, _ScheduleLoader);
  var _super = _createSuper$6(EagerLoader);
  function EagerLoader(entryName, sourceUrl, options) {
    var _this;
    _classCallCheck(this, EagerLoader);
    _this = _super.call(this, entryName, sourceUrl, options);
    _this.deferredModule = _this.loadModule();
    return _this;
  }
  _createClass(EagerLoader, [{
    key: "getModule",
    value: function getModule() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.deferredModule);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return EagerLoader;
}(ScheduleLoader);

var ChunkDependencyNode = /*#__PURE__*/function () {
  function ChunkDependencyNode(url) {
    _classCallCheck(this, ChunkDependencyNode);
    this.url = url;
  }
  _createClass(ChunkDependencyNode, [{
    key: "bootstrap",
    value: function bootstrap() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loader = new EagerLoader(this.url, this.url);
              _context.next = 3;
              return this.loader.getModule();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return ChunkDependencyNode;
}();

var CSSDependencyNode = /*#__PURE__*/function () {
  function CSSDependencyNode(name, cdnPrefix) {
    _classCallCheck(this, CSSDependencyNode);
    this.name = name;
    this.cdnPrefix = cdnPrefix;
  }
  _createClass(CSSDependencyNode, [{
    key: "bootstrap",
    value: function bootstrap() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "".concat(this.cdnPrefix.replace(/\/*$/, '/')).concat(this.name); // 如果已经加载过就不重复加载了
              if (CSSDependencyNode.loadRecords.has(url)) {
                _context.next = 6;
                break;
              }
              this.loader = new EagerLoader(this.name, url, {
                isCss: true
              });
              _context.next = 5;
              return this.loader.getModule();
            case 5:
              CSSDependencyNode.loadRecords.add(url);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return CSSDependencyNode;
}();
// 记录加载，避免重复加载
CSSDependencyNode.loadRecords = new Set();

/**
 * 回调Promise拦截器, Promise变成resolved状态后触发回调
 */
var Barrier = /*#__PURE__*/function () {
  function Barrier() {
    var _this = this;
    _classCallCheck(this, Barrier);
    this.isInnerOpen = false;
    this.innerPromise = new Promise(function (resolve) {
      _this.completePromise = resolve;
    });
  }
  _createClass(Barrier, [{
    key: "isOpen",
    value: function isOpen() {
      return this.isInnerOpen;
    }
    /**
     * 打开拦截器，触发对应的回调
     */
  }, {
    key: "open",
    value: function open() {
      this.isInnerOpen = true;
      this.completePromise(true);
    }
  }, {
    key: "wait",
    value: function wait() {
      return this.innerPromise;
    }
  }]);
  return Barrier;
}();

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 加载策略: 闲时加载
 * （浏览器空闲时加载，底层是 requestIdleCallback）
 * 不支持时自动 polyfill：requestIdleCallback => MessageChannel => setTimeout
 */
var IdleLoader = /*#__PURE__*/function (_ScheduleLoader) {
  _inherits(IdleLoader, _ScheduleLoader);
  var _super = _createSuper$5(IdleLoader);
  function IdleLoader(entryName, sourceUrl, options) {
    var _this;
    _classCallCheck(this, IdleLoader);
    _this = _super.call(this, entryName, sourceUrl, options);
    _this.schedulerHandler = scheduler;
    _this.scheduleCallbackTask = _this.loadWhenIdle();
    return _this;
  }
  _createClass(IdleLoader, [{
    key: "getModule",
    value: function getModule() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.loadState === LoadState.WAITING || this.loadState === LoadState.ERROR)) {
                _context.next = 4;
                break;
              }
              // 取消该闲时任务
              this.schedulerHandler.cancelTask(this.scheduleCallbackTask);
              // 转变为立即加载
              this.deferredModule = this.loadModule();
              return _context.abrupt("return", this.deferredModule);
            case 4:
              return _context.abrupt("return", this.deferredModule);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "loadWhenIdle",
    value: function loadWhenIdle() {
      var _this2 = this;
      return this.schedulerHandler.scheduleTask(function () {
        _this2.deferredModule = _this2.loadModule();
      });
    }
  }]);
  return IdleLoader;
}(ScheduleLoader);

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 加载策略: 按需加载
 * （调用时加载）
 */
var OndemandLoader = /*#__PURE__*/function (_ScheduleLoader) {
  _inherits(OndemandLoader, _ScheduleLoader);
  var _super = _createSuper$4(OndemandLoader);
  function OndemandLoader() {
    _classCallCheck(this, OndemandLoader);
    return _super.apply(this, arguments);
  }
  _createClass(OndemandLoader, [{
    key: "getModule",
    value: function getModule() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.deferredModule = this.loadModule();
              return _context.abrupt("return", this.deferredModule);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return OndemandLoader;
}(ScheduleLoader);

var _SCHEDULE_LOADER_MAP;
var SCHEDULE_LOADER_MAP = (_SCHEDULE_LOADER_MAP = {}, _defineProperty(_SCHEDULE_LOADER_MAP, LoadType.ON_DEMAND, OndemandLoader), _defineProperty(_SCHEDULE_LOADER_MAP, LoadType.IDLE, IdleLoader), _defineProperty(_SCHEDULE_LOADER_MAP, LoadType.EAGER, EagerLoader), _SCHEDULE_LOADER_MAP);
var ExtensionDependencyNode = /*#__PURE__*/function () {
  function ExtensionDependencyNode(name, url, surpportLanguages, language) {
    _classCallCheck(this, ExtensionDependencyNode);
    this.name = name;
    this.url = url;
    this.surpportLanguages = surpportLanguages;
    this.language = language;
    this.loadTypeMap = new Map();
  }
  _createClass(ExtensionDependencyNode, [{
    key: "bootstrap",
    value: function bootstrap() {
      var dependant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _a;
      var loadType = (_a = this.loadTypeMap.get(dependant)) !== null && _a !== void 0 ? _a : LoadType.IDLE;
      this.loader = this.createLoader(loadType);
    }
  }, {
    key: "addLoadType",
    value: function addLoadType(dependant, loadType) {
      this.loadTypeMap.set(dependant !== null && dependant !== void 0 ? dependant : '', loadType);
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.loader) {
                this.bootstrap();
              }
              if (!(this.loader.loadState === LoadState.ERROR)) {
                _context.next = 3;
                break;
              }
              throw new ExtensionError("load extension [".concat(this.name, "] error."));
            case 3:
              _context.next = 5;
              return this.waitSingletonInstance();
            case 5:
              return _context.abrupt("return", this.instance);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "waitSingletonInstance",
    value: function waitSingletonInstance() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var Constructor;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.instance) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!this.barrier) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return this.barrier.wait();
            case 5:
              _context2.next = 17;
              break;
            case 7:
              this.barrier = new Barrier();
              _context2.next = 10;
              return this.loader.getModule();
            case 10:
              Constructor = _context2.sent;
              if (!(typeof Constructor !== 'function')) {
                _context2.next = 14;
                break;
              }
              CustomReportEventDispatcher.loadFail({
                duration: -1,
                module: this.name,
                url: this.url,
                error: new Error("constructor type: ".concat(_typeof(Constructor)))
              });
              throw new ExtensionError("something went wrong in ".concat(this.name, "'s constructor."));
            case 14:
              this.instance = proxyToReport(new Constructor(), this.name, this.url);
              this.instance.bootstraped = false;
              this.barrier.open();
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "dealUrlForMultLanguage",
    value: function dealUrlForMultLanguage(url) {
      var _a;
      var finalUrl = Array.isArray(url) ? url === null || url === void 0 ? void 0 : url[0] : url;
      var jsStartIndex = finalUrl === null || finalUrl === void 0 ? void 0 : finalUrl.lastIndexOf('.js');
      if (jsStartIndex === -1) {
        return finalUrl;
      }
      // 如果组件支持多语言，则处理成多语言url
      if ((_a = this.surpportLanguages) === null || _a === void 0 ? void 0 : _a.includes(this.language)) {
        finalUrl = "".concat(finalUrl.slice(0, jsStartIndex), ".").concat(this.language, ".js");
      }
      return finalUrl;
    }
  }, {
    key: "createLoader",
    value: function createLoader(loadType) {
      var ScheduleLoader = SCHEDULE_LOADER_MAP[loadType];
      return new ScheduleLoader(this.name, this.dealUrlForMultLanguage(this.url));
    }
  }]);
  return ExtensionDependencyNode;
}();

var GenesisDependencyNode = /*#__PURE__*/function () {
  function GenesisDependencyNode() {
    _classCallCheck(this, GenesisDependencyNode);
  }
  _createClass(GenesisDependencyNode, [{
    key: "bootstrap",
    value: function bootstrap() {
      throw new ExtensionError('genesis dependency node should not be called');
    }
  }]);
  return GenesisDependencyNode;
}();
GenesisDependencyNode.nodeName = 'GENESIS_DEPENDENCY_NODE';

/**
 * 将所有的cac整改配置收拢到该文件，将代码里的写死域名之类的也收拢到该文件，在此集中disable相关eslint
 */
var npmConfig = appConfigInstance.getConfig('npm["@tencent/ark-extensions"]');
var React = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.React) || '//docs.idqqimg.com/tim/docs/components/libs/react-common-16.13.1-2bf240.js';
var ReactDOM = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.ReactDOM) || '//docs.idqqimg.com/tim/docs/components/libs/react-common-16.13.1-2bf240.js';
var DEFAULT_COMPONENT_CDN_PREFIX = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.DEFAULT_COMPONENT_CDN_PREFIX) || '//docs.gtimg.com/docs_components';

var COMMON_LIB_WHITELIST = {
  React: React,
  ReactDOM: ReactDOM
};

var LibraryDependencyNode = /*#__PURE__*/function () {
  function LibraryDependencyNode(name) {
    _classCallCheck(this, LibraryDependencyNode);
    this.name = name;
  }
  _createClass(LibraryDependencyNode, [{
    key: "bootstrap",
    value: function bootstrap() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = COMMON_LIB_WHITELIST[this.name];
              if (url) {
                _context.next = 3;
                break;
              }
              throw new ExtensionError("common lib [".concat(this.name, "] is illegal because it's not in white list."));
            case 3:
              if (!(window[this.name] === undefined)) {
                _context.next = 7;
                break;
              }
              this.loader = new EagerLoader(this.name, url);
              _context.next = 7;
              return this.loader.getModule();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return LibraryDependencyNode;
}();

var ModuleDependencyNode = /*#__PURE__*/function () {
  function ModuleDependencyNode(name, cdnPrefix) {
    _classCallCheck(this, ModuleDependencyNode);
    this.name = name;
    this.cdnPrefix = cdnPrefix;
  }
  _createClass(ModuleDependencyNode, [{
    key: "bootstrap",
    value: function bootstrap() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "".concat(this.cdnPrefix.replace(/\/*$/, '/')).concat(this.name);
              if (ModuleDependencyNode.loadRecords.has(url)) {
                _context.next = 6;
                break;
              }
              this.loader = new EagerLoader(this.name, url);
              _context.next = 5;
              return this.loader.getModule();
            case 5:
              ModuleDependencyNode.loadRecords.add(url);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return ModuleDependencyNode;
}();
// 记录加载，避免重复加载
ModuleDependencyNode.loadRecords = new Set();

/**
 * 插件管理器
 *
 * 业务流程：
 * 1. 初始化时获得用户对插件的所有配置
 * 2. 加载所有插件的组件元信息
 * 3. 根据插件配置构建依赖图
 * 4. 加载对应插件时启动依赖加载并获取插件实例
 */
var ExtensionManager = /*#__PURE__*/function () {
  function ExtensionManager(metadataLoader) {
    _classCallCheck(this, ExtensionManager);
    this.metadataLoader = metadataLoader;
    this.createDepGraph();
  }
  /**
   * 添加多个插件配置
   */
  _createClass(ExtensionManager, [{
    key: "addExtensionConfig",
    value: function addExtensionConfig(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.metadataRecord) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return this.metadataLoader.getMetadataRecord();
            case 3:
              this.metadataRecord = _context.sent;
            case 4:
              this.language = this.metadataLoader.getLanguage();
              this.addDepNodeByConfig(config);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 添加单插件配置
     */
  }, {
    key: "addExtensionDescription",
    value: function addExtensionDescription(extension) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var name, loadType, node;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.metadataRecord) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return this.metadataLoader.getMetadataRecord();
            case 3:
              this.metadataRecord = _context2.sent;
            case 4:
              name = extension.name, loadType = extension.loadType;
              node = this.addExtensionDependencyNode(name, loadType);
              node.bootstrap();
              return _context2.abrupt("return", node);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 根据插件名获取插件实例
     * @param {string} extensionName 调用的插件名
     * @param {string?} dependant 调用方名称，用于在插件调用插件时进行限制
     */
  }, {
    key: "getInstance",
    value: function getInstance(extensionName_1) {
      return __awaiter(this, arguments, void 0, function (extensionName) {
        var _this = this;
        var dependantName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GenesisDependencyNode.nodeName;
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _a, e_1, _b, _c, dependants, node, dependencies, _d, dependencies_1, dependencies_1_1, depName, depNode, instance;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                dependants = _this.depGraph.directDependantsOf(extensionName); // 获取的插件不在调用方的依赖声明中时抛出错误
                if (dependants.includes(dependantName)) {
                  _context3.next = 4;
                  break;
                }
                CustomReportEventDispatcher.loadFail({
                  module: extensionName,
                  url: '',
                  duration: -1,
                  error: new Error('cannot find in metadata')
                });
                throw new ExtensionError("Cannot get ".concat(extensionName, " extension in ").concat(dependantName, ", please add configuration !"));
              case 4:
                // 获取插件在依赖图中的节点信息
                node = _this.depGraph.getNodeData(extensionName); // 获取当前插件节点的直接依赖并启动加载
                dependencies = _this.depGraph.directDependenciesOf(extensionName);
                _context3.prev = 6;
                _d = true, dependencies_1 = __asyncValues(dependencies);
              case 8:
                _context3.next = 10;
                return dependencies_1.next();
              case 10:
                dependencies_1_1 = _context3.sent;
                _a = dependencies_1_1.done;
                if (_a) {
                  _context3.next = 22;
                  break;
                }
                _c = dependencies_1_1.value;
                _d = false;
                depName = _c;
                depNode = _this.depGraph.getNodeData(depName); // 第三方依赖等待加载完成，插件依赖则只启动加载
                _context3.next = 19;
                return depNode.bootstrap(extensionName);
              case 19:
                _d = true;
                _context3.next = 8;
                break;
              case 22:
                _context3.next = 27;
                break;
              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](6);
                e_1 = {
                  error: _context3.t0
                };
              case 27:
                _context3.prev = 27;
                _context3.prev = 28;
                if (!(!_d && !_a && (_b = dependencies_1["return"]))) {
                  _context3.next = 32;
                  break;
                }
                _context3.next = 32;
                return _b.call(dependencies_1);
              case 32:
                _context3.prev = 32;
                if (!e_1) {
                  _context3.next = 35;
                  break;
                }
                throw e_1.error;
              case 35:
                return _context3.finish(32);
              case 36:
                return _context3.finish(27);
              case 37:
                _context3.next = 39;
                return node.getInstance();
              case 39:
                instance = _context3.sent;
                return _context3.abrupt("return", instance);
              case 41:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[6, 24, 27, 37], [28,, 32, 36]]);
        })();
      });
    }
    /**
     * 获取依赖图
     */
  }, {
    key: "getDepGraph",
    value: function getDepGraph() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.depGraph);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * 根据 config 创建依赖图
     */
  }, {
    key: "createDepGraph",
    value: function createDepGraph() {
      this.depGraph = new DepGraph();
      var genesisNode = new GenesisDependencyNode();
      this.depGraph.addNode(GenesisDependencyNode.nodeName, genesisNode);
    }
  }, {
    key: "addDepNodeByConfig",
    value: function addDepNodeByConfig(config) {
      var _this2 = this;
      config.forEach(function (desc) {
        var name = desc.name,
          loadType = desc.loadType;
        try {
          var node = _this2.addExtensionDependencyNode(name, loadType);
          _this2.depGraph.addDependency(GenesisDependencyNode.nodeName, node.name);
        } catch (e) {
          console.error(e);
        }
      });
    }
    /**
     * 添加第三方依赖到依赖图中
     */
  }, {
    key: "addLibraryDependencyNode",
    value: function addLibraryDependencyNode(libName) {
      var node = new LibraryDependencyNode(libName);
      this.depGraph.addNode(libName, node);
    }
  }, {
    key: "addModulesDependencyNode",
    value: function addModulesDependencyNode(moduleName, cdnPrefix) {
      var node = new ModuleDependencyNode(moduleName, cdnPrefix);
      this.depGraph.addNode(moduleName, node);
    }
  }, {
    key: "addCSSDependencyNode",
    value: function addCSSDependencyNode(moduleName, cdnPrefix) {
      var node = new CSSDependencyNode(moduleName, cdnPrefix);
      this.depGraph.addNode(moduleName, node);
    }
    /**
     * 添加chunk到依赖图中
     */
  }, {
    key: "addChunkDependencyNode",
    value: function addChunkDependencyNode(chunkUrl) {
      var node = new ChunkDependencyNode(chunkUrl);
      this.depGraph.addNode(chunkUrl, node);
    }
    /**
     * 添加插件依赖到依赖图中
     * @param {string} extensionName 插件名
     * @param {LoadType} loadType 加载时机类型
     * @param {string | undefined} dependant 依赖方名称
     */
  }, {
    key: "addExtensionDependencyNode",
    value: function addExtensionDependencyNode(extensionName, loadType, dependant) {
      var _this3 = this;
      // 节点在依赖图中已存在时，为插件节点添加对应的依赖方对应的 loadType
      // 当前节点对应的插件被加载时会根据依赖方选择对应的加载时机
      if (this.depGraph.hasNode(extensionName)) {
        var _node = this.depGraph.getNodeData(extensionName);
        _node.addLoadType(dependant, loadType);
        return _node;
      }
      var extensionMetadata = this.metadataRecord[extensionName];
      if (!extensionMetadata) {
        throw new ExtensionError("Cannot find ".concat(extensionName, " extension in metadata!"));
      }
      var url = extensionMetadata.url,
        _extensionMetadata$ch = extensionMetadata.chunks,
        chunks = _extensionMetadata$ch === void 0 ? [] : _extensionMetadata$ch,
        _extensionMetadata$de = extensionMetadata.dependencies,
        dependencies = _extensionMetadata$de === void 0 ? {} : _extensionMetadata$de,
        _extensionMetadata$su = extensionMetadata.surpportLanguages,
        surpportLanguages = _extensionMetadata$su === void 0 ? [] : _extensionMetadata$su;
      var _dependencies$commonM = dependencies.commonModules,
        commonModules = _dependencies$commonM === void 0 ? [] : _dependencies$commonM,
        _dependencies$commonL = dependencies.commonLibs,
        commonLibs = _dependencies$commonL === void 0 ? [] : _dependencies$commonL,
        _dependencies$extensi = dependencies.extensions,
        extensions = _dependencies$extensi === void 0 ? [] : _dependencies$extensi,
        _dependencies$css = dependencies.css,
        css = _dependencies$css === void 0 ? [] : _dependencies$css;
      var node = new ExtensionDependencyNode(extensionName, url, surpportLanguages, this.language);
      node.addLoadType(dependant, loadType);
      this.depGraph.addNode(extensionName, node);
      chunks.forEach(function (chunkUrl) {
        _this3.addChunkDependencyNode(chunkUrl);
        _this3.depGraph.addDependency(extensionName, chunkUrl);
      });
      // 添加第三方依赖（React/ReactDOM 等）节点
      commonLibs.forEach(function (libName) {
        _this3.addLibraryDependencyNode(libName);
        _this3.depGraph.addDependency(extensionName, libName);
      });
      /**
       * 添加第三方依赖，与 commonLibs 的区别：
       * 1. commonLibs 扩展性差
       *    1. 只有依赖库在白名单中才加载，不支持 metadata.json 灵活扩展
       *    2. 如果入参不在白名单内，则会导致整个组件加载失败，需要同时升级 extension 和 metadata.json 才行。容错性差。
       * 2. commonModules 支持 metadata.json 动态扩展，等品类都升级到最新 extension 之后，干掉 commonLibs
       */
      commonModules.forEach(function (moduleName) {
        _this3.addModulesDependencyNode(moduleName, _this3.metadataLoader.COMPONENT_CDN_PREFIX);
        _this3.depGraph.addDependency(extensionName, moduleName);
      });
      css.forEach(function (cssName) {
        _this3.addCSSDependencyNode(cssName, _this3.metadataLoader.COMPONENT_CDN_PREFIX);
        _this3.depGraph.addDependency(extensionName, cssName);
      });
      // 添加插件依赖节点
      extensions.forEach(function (description) {
        var _a;
        // 由于组件 package.json 中写的是 loadType string，这里需要转一下
        // 如果没有设置依赖的子组件加载类型，则默认为 ON_DEMAND：调用时加载
        try {
          var depLoadType = (_a = LoadType[description.loadType.toString()]) !== null && _a !== void 0 ? _a : LoadType.ON_DEMAND;
          _this3.addExtensionDependencyNode(description.name, depLoadType, extensionName);
          _this3.depGraph.addDependency(extensionName, description.name);
        } catch (e) {
          console.error(e);
        }
      });
      return node;
    }
  }]);
  return ExtensionManager;
}();
ExtensionManager = __decorate([__param(0, IMetadataLoader), __metadata("design:paramtypes", [Object])], ExtensionManager);

var IExtensionManager = createDecorator('IExtensionManager');

/**
 * 目前只支持在 window、document 和 document.body 下挂载 DOM 事件
 */
var EventTarget;
(function (EventTarget) {
  EventTarget[EventTarget["WINDOW"] = 0] = "WINDOW";
  EventTarget[EventTarget["DOCUMENT"] = 1] = "DOCUMENT";
  EventTarget[EventTarget["DOCUMENT_BODY"] = 2] = "DOCUMENT_BODY";
})(EventTarget || (EventTarget = {}));
/**
 * 目前支持插件挂载的事件种类
 */
var EventType;
(function (EventType) {
  // 浏览器原生事件类型
  EventType["RESIZE"] = "resize";
  EventType["MOUSE_DOWN"] = "mousedown";
  EventType["MOUSE_MOVE"] = "mousemove";
  EventType["MOUSE_UP"] = "mouseup";
  EventType["KEY_UP"] = "keyup";
  EventType["KEY_DOWN"] = "keydown";
  EventType["CLICK"] = "click";
  EventType["TOUCH_START"] = "touchstart";
  EventType["TOUCH_MOVE"] = "touchmove";
  EventType["TOUCH_END"] = "touchend";
  EventType["POP_STATE"] = "popState";
  EventType["VISIBILITY_CHANGE"] = "visibilitychange";
  EventType["ONLINE"] = "online";
  EventType["OFFLINE"] = "offline";
  EventType["MESSAGE"] = "message";
  // 自定义事件类型
  EventType["CUSTOM"] = "custom";
})(EventType || (EventType = {}));

var EventManager = /*#__PURE__*/function () {
  function EventManager() {
    _classCallCheck(this, EventManager);
    this.eventListenerSet = new Set();
    this.customEventListenerMap = new Map();
  }
  /**
   * 挂载插件能使用的全局事件
   */
  // eslint-disable-next-line complexity
  _createClass(EventManager, [{
    key: "listen",
    value: function listen(listener) {
      var type = listener.type;
      switch (type) {
        case EventType.RESIZE:
        case EventType.MOUSE_DOWN:
        case EventType.MOUSE_MOVE:
        case EventType.MOUSE_UP:
        case EventType.KEY_UP:
        case EventType.KEY_DOWN:
        case EventType.CLICK:
        case EventType.TOUCH_START:
        case EventType.TOUCH_MOVE:
        case EventType.TOUCH_END:
        case EventType.POP_STATE:
        case EventType.VISIBILITY_CHANGE:
        case EventType.ONLINE:
        case EventType.OFFLINE:
        case EventType.MESSAGE:
          return this.bindEvent(listener);
        case EventType.CUSTOM:
          return this.bindCustomEvent(listener);
        default:
          throw new ExtensionError("[".concat(type, "] event is not supported to use in extensions."));
      }
    }
  }, {
    key: "listenCustomEvent",
    value: function listenCustomEvent(customEventListener) {
      this.bindCustomEvent(customEventListener);
      return {
        name: customEventListener.name,
        fire: this.dispatchCustomEvent.bind(this, customEventListener.name)
      };
    }
  }, {
    key: "dispatchCustomEvent",
    value: function dispatchCustomEvent(customEventName, params) {
      var event = new CustomEvent(customEventName, {
        detail: params
      });
      this.node.dispatchEvent(event);
    }
    /**
     * 移除监听函数fn
     */
  }, {
    key: "remove",
    value: function remove(listener) {
      if (!this.eventListenerSet.has(listener)) {
        throw new ExtensionError("unable to remove [".concat(listener.type, "] event which is not in your namespace or not bound."));
      }
      var name = listener.name,
        type = listener.type,
        fn = listener.fn,
        options = listener.options;
      if (type === EventType.CUSTOM) {
        this.node.removeEventListener(name, fn, options);
        this.customEventListenerMap["delete"](name);
        return;
      }
      this.node.removeEventListener(type, fn, options);
      this.eventListenerSet["delete"](listener);
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var _this = this;
      this.eventListenerSet.forEach(function (listener) {
        _this.remove(listener);
      });
      this.customEventListenerMap.forEach(function (listener) {
        _this.remove(listener);
      });
    }
    /**
     * 绑定具体事件
     * @todo 一期先将事件挂载在原 dom 上，简单限制事件的类型，后续做处理
     */
  }, {
    key: "bindEvent",
    value: function bindEvent(listener) {
      if (this.eventListenerSet.has(listener)) throw new ExtensionError("duplicated [".concat(listener.type, "] event."));
      var type = listener.type,
        fn = listener.fn,
        options = listener.options;
      this.node.addEventListener(type, fn, options);
      this.eventListenerSet.add(listener);
    }
  }, {
    key: "bindCustomEvent",
    value: function bindCustomEvent(listener) {
      var name = listener.name;
      if (this.customEventListenerMap.has(name)) throw new ExtensionError("duplicated [".concat(name, "] event."));
      // 如果是自定义事件，则用名字来作为事件名
      var type = name;
      var fn = listener.fn,
        options = listener.options;
      this.node.addEventListener(type, fn, options);
      this.customEventListenerMap.set(name, listener);
    }
  }]);
  return EventManager;
}();

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DocumentBodyEventManager = /*#__PURE__*/function (_EventManager) {
  _inherits(DocumentBodyEventManager, _EventManager);
  var _super = _createSuper$3(DocumentBodyEventManager);
  function DocumentBodyEventManager() {
    var _this;
    _classCallCheck(this, DocumentBodyEventManager);
    _this = _super.apply(this, arguments);
    _this.node = document.body;
    return _this;
  }
  return _createClass(DocumentBodyEventManager);
}(EventManager);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DocumentEventManager = /*#__PURE__*/function (_EventManager) {
  _inherits(DocumentEventManager, _EventManager);
  var _super = _createSuper$2(DocumentEventManager);
  function DocumentEventManager() {
    var _this;
    _classCallCheck(this, DocumentEventManager);
    _this = _super.apply(this, arguments);
    _this.node = document;
    return _this;
  }
  return _createClass(DocumentEventManager);
}(EventManager);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var WindowEventManager = /*#__PURE__*/function (_EventManager) {
  _inherits(WindowEventManager, _EventManager);
  var _super = _createSuper$1(WindowEventManager);
  function WindowEventManager() {
    var _this;
    _classCallCheck(this, WindowEventManager);
    _this = _super.apply(this, arguments);
    _this.node = window;
    return _this;
  }
  return _createClass(WindowEventManager);
}(EventManager);

var ExtensionEvent = /*#__PURE__*/function () {
  function ExtensionEvent() {
    _classCallCheck(this, ExtensionEvent);
    this.initEventManagerPool();
  }
  _createClass(ExtensionEvent, [{
    key: "addListener",
    value: function addListener(listener) {
      var target = listener.target;
      var eventManager = this.eventManagerPool[target];
      return eventManager.listen(listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      var target = listener.target;
      var eventManager = this.eventManagerPool[target];
      return eventManager.remove(listener);
    }
  }, {
    key: "removeAllListener",
    value: function removeAllListener() {
      var eventManagers = Object.values(this.eventManagerPool);
      eventManagers.forEach(function (eventManager) {
        eventManager.removeAll();
      });
    }
  }, {
    key: "initEventManagerPool",
    value: function initEventManagerPool() {
      var _this$eventManagerPoo;
      var windowEventManager = new WindowEventManager();
      var documentEventManager = new DocumentEventManager();
      var documentBodyEventManager = new DocumentBodyEventManager();
      this.eventManagerPool = (_this$eventManagerPoo = {}, _defineProperty(_this$eventManagerPoo, EventTarget.WINDOW, windowEventManager), _defineProperty(_this$eventManagerPoo, EventTarget.DOCUMENT, documentEventManager), _defineProperty(_this$eventManagerPoo, EventTarget.DOCUMENT_BODY, documentBodyEventManager), _this$eventManagerPoo);
    }
  }]);
  return ExtensionEvent;
}();

var IExtensionEvent = createDecorator('IExtensionEvent');

var IExtensionContainerService = createDecorator('IExtensionContainerService');

var DependentServiceCombinder = /*#__PURE__*/function () {
  function DependentServiceCombinder(docMetaDomain, userInfoDomain, authDomain, fileDomain, likeDomain, folderDomain, templateDomain, accountDomain, loginDomain, notificationDomain, shareDomain, messageDomain, collaborateDomain, notifyScopeDomain, atMessageDomain, fileInfoDomain, connectionControllerService, accountApplication, enterpriseAccountApplication, docsManagementService, extensionEvent, extensionContainerService) {
    _classCallCheck(this, DependentServiceCombinder);
    this.docMetaDomain = docMetaDomain;
    this.userInfoDomain = userInfoDomain;
    this.authDomain = authDomain;
    this.fileDomain = fileDomain;
    this.likeDomain = likeDomain;
    this.folderDomain = folderDomain;
    this.templateDomain = templateDomain;
    this.accountDomain = accountDomain;
    this.loginDomain = loginDomain;
    this.notificationDomain = notificationDomain;
    this.shareDomain = shareDomain;
    this.messageDomain = messageDomain;
    this.collaborateDomain = collaborateDomain;
    this.notifyScopeDomain = notifyScopeDomain;
    this.atMessageDomain = atMessageDomain;
    this.fileInfoDomain = fileInfoDomain;
    this.connectionControllerService = connectionControllerService;
    this.accountApplication = accountApplication;
    this.enterpriseAccountApplication = enterpriseAccountApplication;
    this.docsManagementService = docsManagementService;
    this.extensionEvent = extensionEvent;
    this.extensionContainerService = extensionContainerService;
  }
  _createClass(DependentServiceCombinder, [{
    key: "getExtensionService",
    value: function getExtensionService(originExtensionService, dependantExtensionName) {
      return {
        // 传递给插件内具有限制的 getExtension，只能调用在 dependantExtensionName 中有配置的组件，没有配置会报错
        getExtension: function getExtension(childExtensionName) {
          return originExtensionService.safeGetExtension.call(originExtensionService, childExtensionName, dependantExtensionName);
        },
        fireExtensionEvent: originExtensionService.fireExtensionEvent.bind(originExtensionService, dependantExtensionName)
      };
    }
  }, {
    key: "getDomainService",
    value: function getDomainService() {
      return {
        docMetaDomain: this.docMetaDomain,
        userInfoDomain: this.userInfoDomain,
        authDomain: this.authDomain,
        fileDomain: this.fileDomain,
        likeDomain: this.likeDomain,
        folderDomain: this.folderDomain,
        templateDomain: this.templateDomain,
        accountDomain: this.accountDomain,
        loginDomain: this.loginDomain,
        notificationDomain: this.notificationDomain,
        shareDomain: this.shareDomain,
        messageDomain: this.messageDomain,
        collaborateDomain: this.collaborateDomain,
        notifyScopeDomain: this.notifyScopeDomain,
        atMessageDomain: this.atMessageDomain,
        fileInfoDomain: this.fileInfoDomain
      };
    }
  }, {
    key: "getApplicationService",
    value: function getApplicationService() {
      return {
        accountApplication: this.accountApplication,
        enterpriseAccountApplication: this.enterpriseAccountApplication,
        connectionControllerService: this.connectionControllerService,
        docsManagementService: this.docsManagementService
      };
    }
  }, {
    key: "getToolService",
    value: function getToolService() {
      return {
        networkRequest: networkRequest,
        event: this.extensionEvent
      };
    }
  }, {
    key: "getExtensionContainerService",
    value: function getExtensionContainerService(extensionName) {
      return {
        createContainerIfUnspecified: this.extensionContainerService.createContainerIfUnspecified.bind(this.extensionContainerService, extensionName),
        createSandboxContainerIfUnspecified: this.extensionContainerService.createSandboxContainerIfUnspecified.bind(this.extensionContainerService, extensionName)
      };
    }
  }]);
  return DependentServiceCombinder;
}();
DependentServiceCombinder = __decorate([__param(0, IDocMetaDomainService), __param(1, IUserInfoDomainService), __param(2, IAuthDomainService), __param(3, IFileDomainService), __param(4, ILikeDomainService), __param(5, IFolderDomainService), __param(6, ITemplateDomainService), __param(7, IAccountDomainService), __param(8, ILoginDomainService), __param(9, INotificationDomainService), __param(10, IShareDomainService), __param(11, IMessageDomainService), __param(12, ICollaborateDomainService), __param(13, INotifyScopeDomainService), __param(14, IAtMessageDomainService), __param(15, IFileInfoDomainService), __param(16, IConnectionControllerService), __param(17, IAccountApplicationService), __param(18, IEnterpriseAccountApplicationService), __param(19, IDocsManagementService), __param(20, IExtensionEvent), __param(21, IExtensionContainerService), __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])], DependentServiceCombinder);

var IDependentServiceCombinder = createDecorator('IDependentServiceCombinder');

var IExtensionConfigManager = createDecorator('IExtensionConfigManager');

var ExtensionService = /*#__PURE__*/function () {
  function ExtensionService(dependentServiceCombinder, extensionConfigManager, extensionManager, domainUpdater) {
    _classCallCheck(this, ExtensionService);
    this.dependentServiceCombinder = dependentServiceCombinder;
    this.extensionConfigManager = extensionConfigManager;
    this.extensionManager = extensionManager;
    this.domainUpdater = domainUpdater;
    this.extensionEventEmitter = new Emitter();
  }
  _createClass(ExtensionService, [{
    key: "updateDomainWithClientVars",
    value: function updateDomainWithClientVars(clientVars) {
      var proxy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.domainUpdater.updateDomainWithClientVars(clientVars, proxy);
    }
  }, {
    key: "updateDomainWithRequests",
    value: function updateDomainWithRequests(docId, u) {
      this.domainUpdater.updateDomainWithRequests({
        docId: docId,
        u: u
      });
    }
    /**
     * 扫描插件配置，会重新初始化 ExtensionConfig
     */
  }, {
    key: "scanAndHandleExtensions",
    value: function scanAndHandleExtensions(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.addExtensionConfig(config));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "addExtensionConfig",
    value: function addExtensionConfig(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.extensionConfigReadyBarrier) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return this.extensionConfigReadyBarrier.wait();
            case 3:
              _context2.next = 6;
              break;
            case 5:
              this.extensionConfigReadyBarrier = new Barrier();
            case 6:
              _context2.next = 8;
              return this.extensionConfigManager.addExtensionConfig(config);
            case 8:
              this.extensionConfigReadyBarrier.open();
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "addExtensionDescription",
    value: function addExtensionDescription(extensionDescription) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.extensionConfigManager.addExtensionDescription(extensionDescription);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "subscribeExtensionEvent",
    value: function subscribeExtensionEvent(callback) {
      this.extensionEventEmitter.event(function (event) {
        callback(event.extensionName, event.type);
      });
    }
  }, {
    key: "fireExtensionEvent",
    value: function fireExtensionEvent(extensionName, type) {
      var event = {
        extensionName: extensionName,
        type: type
      };
      this.extensionEventEmitter.fire(event);
    }
    /**
     * 获取插件实例，该函数的实现需保证幂等：
     * 1. createExtension 创建的是单例
     * 2. 插件的 bootstrap 函数不会重复调用
     */
  }, {
    key: "getExtension",
    value: function getExtension(extensionName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.safeGetExtension(extensionName));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "disposeAllExtensions",
    value: function disposeAllExtensions() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "getExtensionConfig",
    value: function getExtensionConfig() {
      return this.extensionConfigManager.getExtensionConfig();
    }
  }, {
    key: "getExtensionDepGraph",
    value: function getExtensionDepGraph() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.extensionManager.getDepGraph());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
    /**
     * 通过 dependantName 限制所获取的插件实例
     * 直接调用 ExtensionService 时只能够调用项目中配置的插件
     * 插件内调用时只能够调用内部配置的子依赖插件
     */
  }, {
    key: "safeGetExtension",
    value: function safeGetExtension(extensionName, dependantName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var extension;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.extensionConfigReadyBarrier.wait();
            case 2:
              _context6.next = 4;
              return this.extensionManager.getInstance(extensionName, dependantName);
            case 4:
              extension = _context6.sent;
              this.bootstrapExtension(extensionName, extension);
              return _context6.abrupt("return", extension);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "bootstrapExtension",
    value: function bootstrapExtension(extensionName, extension) {
      if (extension.bootstraped) {
        return;
      }
      var restrictedExtensionService = this.dependentServiceCombinder.getExtensionService(this, extensionName);
      var restrictedDomainService = this.dependentServiceCombinder.getDomainService();
      var restrictedApplicationService = this.dependentServiceCombinder.getApplicationService();
      var extensionToolService = this.dependentServiceCombinder.getToolService();
      var extensionContainerService = this.dependentServiceCombinder.getExtensionContainerService(extensionName);
      // 如果查找不到该插件的 description，说明使用方并没有直接依赖该插件，container 需要在直接依赖它的地方使用 show 传入
      // 若 show 时也没有传入 container，extensionContainerService 会自动为其分配 container
      var extensionDesc = this.extensionConfigManager.findExtensionDescription(extensionName);
      var containerId = extensionDesc === null || extensionDesc === void 0 ? void 0 : extensionDesc.containerId;
      var container = this.getContainer(containerId);
      extension.bootstrap({
        extensionService: restrictedExtensionService,
        domainService: restrictedDomainService,
        toolService: extensionToolService,
        applicationService: restrictedApplicationService,
        containerService: extensionContainerService,
        extensionName: extensionName,
        container: container
      });
      // eslint-disable-next-line no-param-reassign
      extension.bootstraped = true;
    }
  }, {
    key: "getContainer",
    value: function getContainer(containerId) {
      var container = null;
      if (containerId) container = document.getElementById(containerId);
      return container;
    }
  }]);
  return ExtensionService;
}();
ExtensionService = __decorate([__param(0, IDependentServiceCombinder), __param(1, IExtensionConfigManager), __param(2, IExtensionManager), __param(3, IDomainUpdater), __metadata("design:paramtypes", [Object, Object, Object, Object])], ExtensionService);

var ExtensionContainerService = /*#__PURE__*/function () {
  function ExtensionContainerService() {
    _classCallCheck(this, ExtensionContainerService);
    this.containerCollectionId = '__unspesified_extension_container_collection__';
  }
  _createClass(ExtensionContainerService, [{
    key: "createContainerIfUnspecified",
    value: function createContainerIfUnspecified(id) {
      this.unspecifiedContainerCollection = this.getUnspecifiedContainerCollection();
      var container = this.unspecifiedContainerCollection.querySelector("#".concat(id));
      if (container) return container;
      container = document.createElement('div');
      container.setAttribute('id', id);
      this.unspecifiedContainerCollection.appendChild(container);
      return container;
    }
  }, {
    key: "createSandboxContainerIfUnspecified",
    value: function createSandboxContainerIfUnspecified() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "getUnspecifiedContainerCollection",
    value: function getUnspecifiedContainerCollection() {
      var collection = document.getElementById(this.containerCollectionId);
      if (!collection) {
        collection = document.createElement('div');
        collection.setAttribute('id', this.containerCollectionId);
        document.body.appendChild(collection);
      }
      return collection;
    }
  }]);
  return ExtensionContainerService;
}();

var ExtensionConfigManager = /*#__PURE__*/function () {
  function ExtensionConfigManager(extensionManager) {
    _classCallCheck(this, ExtensionConfigManager);
    this.extensionManager = extensionManager;
    this.extensionConfig = [];
  }
  _createClass(ExtensionConfigManager, [{
    key: "addExtensionConfig",
    value: function addExtensionConfig(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.extensionConfig = this.extensionConfig.concat(config);
              _context.next = 3;
              return this.extensionManager.addExtensionConfig(config);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "addExtensionDescription",
    value: function addExtensionDescription(description) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.assertNoDuplicatedDescription(description);
              this.extensionConfig.push(description);
              _context2.next = 4;
              return this.extensionManager.addExtensionDescription(description);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getExtensionConfig",
    value: function getExtensionConfig() {
      return this.extensionConfig;
    }
  }, {
    key: "findExtensionDescription",
    value: function findExtensionDescription(name) {
      var description = this.extensionConfig.find(function (desc) {
        return desc.name === name;
      });
      return description;
    }
  }, {
    key: "iterateExtensionConfig",
    value: function iterateExtensionConfig(callback) {
      this.extensionConfig.forEach(callback);
    }
  }, {
    key: "assertNoDuplicatedDescription",
    value: function assertNoDuplicatedDescription(newExtensionDescription) {
      var duplicatedDesc = this.extensionConfig.find(function (desc) {
        return desc.name === newExtensionDescription.name;
      });
      if (duplicatedDesc) {
        // 出现重复则报错
        throw new ExtensionError("duplicated extension config of ".concat(newExtensionDescription.name, "."));
      }
    }
  }]);
  return ExtensionConfigManager;
}();
ExtensionConfigManager = __decorate([__param(0, IExtensionManager), __metadata("design:paramtypes", [Object])], ExtensionConfigManager);

var IExtensionService = createDecorator('IExtensionService');

var METADATA_REQUEST_CACHE_KEY = Symbol["for"]('__META_REQUEST_CACHE__');
var _window$location = window.location,
  protocol = _window$location.protocol,
  host = _window$location.host;
var DEFAULT_METADATA_URL = "".concat(protocol, "//").concat(host, "/components/docs/metadata{{specifiedVersionKey}}.json?t={{time}}");
var MetadataLoader = /*#__PURE__*/function () {
  function MetadataLoader(options) {
    _classCallCheck(this, MetadataLoader);
    var _a, _b, _c;
    this.COMPONENT_CDN_PREFIX = (_a = options.componentCdnPrefix) !== null && _a !== void 0 ? _a : DEFAULT_COMPONENT_CDN_PREFIX;
    this.specifiedVersionKey = options.specifiedVersion ? ".v".concat(options.specifiedVersion) : '';
    this.METADATA_URL = (_b = options.metadataUrl) !== null && _b !== void 0 ? _b : DEFAULT_METADATA_URL;
    /**
     * TODO - 优化
     * language 只有 extension-manager 处理相关逻辑，那么这个配置就不适合放在 metadata-loader。
     * 应该在 extension-accessor 初始化 extension-manager 的时候，把 language 作为配置传给 extension-manager.
     */
    this.language = (_c = options.language) !== null && _c !== void 0 ? _c : '';
  }
  _createClass(MetadataLoader, [{
    key: "metadataRequestCacheMap",
    get: function get() {
      if (globalThis[METADATA_REQUEST_CACHE_KEY] === undefined) {
        globalThis[METADATA_REQUEST_CACHE_KEY] = new Map();
      }
      return globalThis[METADATA_REQUEST_CACHE_KEY];
    }
  }, {
    key: "getMetadataRecord",
    value: function getMetadataRecord() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var hasCache, requestPromise, metadataRecord;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              hasCache = this.metadataRequestCacheMap.has(this.specifiedVersionKey);
              requestPromise = hasCache ? this.metadataRequestCacheMap.get(this.specifiedVersionKey) : this.requestMetadataRecord();
              if (!hasCache) {
                this.metadataRequestCacheMap.set(this.specifiedVersionKey, requestPromise);
              }
              _context.next = 5;
              return requestPromise;
            case 5:
              metadataRecord = _context.sent;
              return _context.abrupt("return", metadataRecord);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * TODO - 优化
     * 其实只要声明成员变量为 public readonly language: string 就行
     */
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this.language;
    }
    /**
     * 通过script加载metadata.js
     * 因为本地加载时file协议浏览器限制不能发起请求，为了拿到metadata.json的内容，将它改为js文件，并赋值给全局变量window.METADATA_DATA
     */
  }, {
    key: "loadMetadataScript",
    value: function loadMetadataScript(url) {
      return new Promise(function (resolve, reject) {
        var scriptTag = document.createElement('script');
        scriptTag.src = url;
        scriptTag.async = false;
        scriptTag.type = 'text/javascript';
        scriptTag.addEventListener('load', function () {
          return resolve();
        });
        scriptTag.addEventListener('error', function (err) {
          return reject(err);
        });
        document.body.appendChild(scriptTag);
      });
    }
  }, {
    key: "requestMetadataRecord",
    value: function requestMetadataRecord() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var url, start, response, end, duration, _response, _response$data, data, metadataRecord;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = this.METADATA_URL.replace('{{specifiedVersionKey}}', this.specifiedVersionKey).replace('{{time}}', Date.now().toString());
              start = performance.now();
              if (!(protocol !== 'http:' && protocol !== 'https:' && this.METADATA_URL.includes('js') && !this.METADATA_URL.includes('json'))) {
                _context2.next = 14;
                break;
              }
              _context2.prev = 3;
              _context2.next = 6;
              return this.loadMetadataScript(url);
            case 6:
              response = {
                data: window.METADATA_DATA,
                status: 0
              };
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](3);
              response = {
                data: {},
                status: _context2.t0
              };
            case 12:
              _context2.next = 17;
              break;
            case 14:
              _context2.next = 16;
              return networkRequest.get(url);
            case 16:
              response = _context2.sent;
            case 17:
              end = performance.now();
              duration = Math.floor(end - start);
              if (response.data) {
                _context2.next = 22;
                break;
              }
              CustomReportEventDispatcher.loadFail({
                module: 'metadata',
                error: new Error(response.status.toString()),
                duration: duration,
                start: start
              });
              throw new ExtensionError("request metadata error, error code: [".concat(response.status, "]."));
            case 22:
              _response = response, _response$data = _response.data, data = _response$data === void 0 ? {} : _response$data;
              metadataRecord = Object.values(data).reduce(function (record, extension) {
                return Object.assign(Object.assign({}, record), _defineProperty({}, extension.name, Object.assign(Object.assign({}, extension), {
                  url: _this.getMetadataUrl(extension)
                })));
              }, {});
              return _context2.abrupt("return", metadataRecord);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 9]]);
      }));
    }
  }, {
    key: "getMetadataUrl",
    value: function getMetadataUrl(extension) {
      var _this2 = this;
      if (Array.isArray(extension.url)) {
        return extension.url.map(function (url) {
          return "".concat(_this2.COMPONENT_CDN_PREFIX, "/").concat(url);
        });
      }
      return ["".concat(this.COMPONENT_CDN_PREFIX, "/").concat(extension.url)];
    }
  }]);
  return MetadataLoader;
}();

var GLOBAL_INSTANTIATION_SERVICE_KEY = '__ARK_EXTENSION_INSTANTIATION_SERVICE__';
var GLOBAL_EXTENSION_SERVICE_KEY = '__ARK_EXTENSION_SERVICE__';
// #region ================================= 没有 di 容器的接入方式 ====================================
function createExtensionService() {
  var createOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var globalExtensionService = globalThis[GLOBAL_EXTENSION_SERVICE_KEY];
  if (globalExtensionService) return globalExtensionService;
  // 初始化 ExtensionService
  var serviceRegister = new ServiceRegister();
  var serviceCollection = new ServiceCollection();
  var options = {
    serviceRegister: serviceRegister,
    serviceCollection: serviceCollection
  };
  registerExtensionService(options, createOptions);
  injectExtensionServiceToCollection(options);
  var instantiationService = initInstantiationService(serviceCollection);
  globalThis[GLOBAL_INSTANTIATION_SERVICE_KEY] = instantiationService;
  // eslint-disable-next-line no-multi-assign
  var extensionService = globalThis[GLOBAL_EXTENSION_SERVICE_KEY] = getExtensionService(instantiationService);
  initReporters();
  return extensionService;
}
function getExtensionService(instantiationService) {
  return instantiationService.invokeFunction(function (accessor) {
    return accessor.get(IExtensionService);
  });
}
// #endregion =======================================================================================
// #region ================================== 有 di 容器的接入方式 =====================================
/**
 * 将 ExtensionService 及相关的服务（包括 Application、Domain）注入到指定的容器
 */
function registerExtensionService(options) {
  var createOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  registerCoreServices(options, createOptions);
  registerDependentService(options, createOptions);
}
function injectExtensionServiceToCollection(options) {
  var serviceRegister = options.serviceRegister;
  var serviceCollection = options.serviceCollection;
  var serviceDescriptors = serviceRegister.getServiceDescriptors();
  serviceDescriptors.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      id = _ref2[0],
      descriptor = _ref2[1];
    serviceCollection.set(id, descriptor);
  });
}
function initInstantiationService(serviceCollection) {
  return new InstantiationService(serviceCollection);
}
/**
 * 仅将 ExtensionService 及其内部的服务注入到指定的容器
 */
function registerCoreServices(options) {
  var createOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a;
  var serviceRegister = options.serviceRegister;
  serviceRegister.register(IExtensionService, ExtensionService);
  serviceRegister.register(IExtensionConfigManager, ExtensionConfigManager);
  serviceRegister.register(IMetadataLoader, MetadataLoader, [(_a = createOptions.metadataLoaderOptions || createOptions.metadataLoader) !== null && _a !== void 0 ? _a : {}]);
  serviceRegister.register(IExtensionManager, ExtensionManager);
}
/**
 * 将 ExtensionService 相关的服务（包括 Application、Domain）注入到指定的容器
 */
function registerDependentService(options) {
  var createOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var serviceRegister = options.serviceRegister;
  var isEnterprise = createOptions.isEnterprise;
  // #region domain service register
  serviceRegister.register(IDomainUpdater, DomainUpdater);
  serviceRegister.register(INetworkRequestService, NetworkRequestService);
  serviceRegister.register(IAuthDomainService, AuthDomainService);
  serviceRegister.register(INotificationDomainService, NotificationDomainService);
  serviceRegister.register(IShareDomainService, ShareDomainService);
  serviceRegister.register(ICollaborateDomainService, CollaborateDomainService);
  serviceRegister.register(IAccountDomainService, AccountDomainService);
  serviceRegister.register(IEnterpriseAccountDomainService, EnterpriseAccountDomainService);
  serviceRegister.register(IDocMetaDomainService, isEnterprise ? EnterpriseDocMetaDomainService : DocMetaDomainService);
  serviceRegister.register(IUserInfoDomainService, UserInfoDomainService);
  serviceRegister.register(IFileDomainService, FileDomainService);
  serviceRegister.register(IFileInfoDomainService, FileInfoDomainService);
  serviceRegister.register(IFolderDomainService, FolderDomainService);
  serviceRegister.register(ITemplateDomainService, TemplateDomainService);
  serviceRegister.register(ILoginDomainService, LoginDomainService);
  serviceRegister.register(IMessageDomainService, MessageDomainService);
  serviceRegister.register(INotifyScopeDomainService, NotifyScopeDomainService);
  serviceRegister.register(IAtMessageDomainService, AtMessageDomainService);
  serviceRegister.register(ILikeDomainService, isEnterprise ? EnterpriseLikeDomainService : LikeDomainService);
  // #endregion
  // #region application service register
  serviceRegister.register(IConnectionControllerService, ConnectionControllerService);
  serviceRegister.register(IAccountApplicationService, AccountApplicationService);
  serviceRegister.register(IEnterpriseAccountApplicationService, EnterpriseAccountApplicationService);
  serviceRegister.register(IDocsManagementService, DocsManagementService);
  // #endregion
  // #region getExtension register
  serviceRegister.register(IDependentServiceCombinder, DependentServiceCombinder);
  // #endregion
  // #region tool service register
  serviceRegister.register(IExtensionEvent, ExtensionEvent);
  // #endregion
  // #region container manager register
  serviceRegister.register(IExtensionContainerService, ExtensionContainerService);
  // #endregion
}
// #endregion =======================================================================================

var version = "3.22.1";

/**
 * 代理宿主环境的 ScirptLoader
 */
var ScriptLoaderProxy = /*#__PURE__*/function () {
  function ScriptLoaderProxy(scriptLoader) {
    _classCallCheck(this, ScriptLoaderProxy);
    this.scriptLoader = scriptLoader || window.ScriptLoader || window.SLR;
    // 这里需要 Proxy 是因为在某些宿主环境下面会访问原有的 ScriptLoader 上的一些属性
    return new Proxy(this, {
      set: function set(target, prop, value) {
        if (target.scriptLoader[prop] !== undefined) {
          target.scriptLoader[prop] = value;
          return true;
        }
        target[prop] = value;
        return true;
      },
      get: function get(target, prop) {
        if (target[prop]) {
          return target[prop];
        }
        if (target.scriptLoader[prop]) {
          if (typeof target.scriptLoader[prop] === 'function') {
            return target.scriptLoader[prop].bind(target.scriptLoader);
          }
          return target.scriptLoader[prop];
        }
      }
    });
  }
  _createClass(ScriptLoaderProxy, [{
    key: "init",
    value: function init(assetsUrl, successCallback, failCallback, retry) {
      this.scriptLoader.init(assetsUrl, successCallback, failCallback, retry);
    }
  }, {
    key: "load",
    value: function load(moduleName, successCallback, failCallback, retry) {
      this.scriptLoader.load(moduleName, successCallback, failCallback, retry);
    }
  }, {
    key: "dispatch",
    value: function dispatch(eventName, detail) {
      this.scriptLoader.dispatch(eventName, detail);
    }
  }, {
    key: "listen",
    value: function listen(eventName, callback) {
      this.scriptLoader.listen(eventName, callback);
    }
  }]);
  return ScriptLoaderProxy;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ScriptLoaderAdapter = /*#__PURE__*/function (_ScriptLoaderProxy) {
  _inherits(ScriptLoaderAdapter, _ScriptLoaderProxy);
  var _super = _createSuper(ScriptLoaderAdapter);
  function ScriptLoaderAdapter(scriptLoader) {
    var _this;
    _classCallCheck(this, ScriptLoaderAdapter);
    _this = _super.call(this, scriptLoader);
    _this.__adpater__ = true;
    _this.__version__ = version;
    _this.isReady = false;
    _this.onReadyEmitter = new Emitter();
    _this.fcModuleMap = new Map();
    _this.extensionService = createExtensionService();
    _this.domainUpdater = _this.extensionService.domainUpdater;
    var extensionConfigInited = _this.extensionService.getExtensionConfig();
    if (!extensionConfigInited) _this.extensionService.scanAndHandleExtensions([]);
    _this.onReady = _this.onReadyEmitter.event;
    return _this;
  }
  _createClass(ScriptLoaderAdapter, [{
    key: "ready",
    value: function ready() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.updateDomainWithClientVars();
            case 2:
              setTimeout(function () {
                _this2.isReady = true;
                _this2.onReadyEmitter.fire();
              }, 0);
              return _context.abrupt("return", this);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "registerExternalModule",
    value: function registerExternalModule(moduleName, moduleInstance) {
      if (this.fcModuleMap.has(moduleName)) {
        return;
      }
      moduleInstance.bootstrap(this.extensionService, this);
      this.fcModuleMap.set(moduleName, moduleInstance);
    }
  }, {
    key: "loadExternalModule",
    value: function loadExternalModule(moduleName, successCallback, failCalback) {
      var fcModule = this.fcModuleMap.get(moduleName);
      if (fcModule !== undefined) {
        successCallback(fcModule);
      } else {
        failCalback === null || failCalback === void 0 ? void 0 : failCalback();
      }
    }
  }, {
    key: "load",
    value: function load(moduleName, successCallback, failCalback, retry) {
      var _this3 = this;
      if (!this.isReady) {
        this.onReady(function () {
          _this3.load(moduleName, successCallback, failCalback, retry);
        });
        return;
      }
      if (!this.fcModuleMap.has(moduleName)) {
        _get(_getPrototypeOf(ScriptLoaderAdapter.prototype), "load", this).call(this, moduleName, successCallback, failCalback, retry);
        return;
      }
      this.loadExternalModule(moduleName, successCallback, failCalback);
    }
    /**
     * 当 clientVars 不为 undefined 时执行 updateDomainWithClientVars 来更新数据
     * (部分场景下 clientVars 可能存在但是不完整，因此需要判断是否有 padId 来确认是否在文档详情页中)
     */
  }, {
    key: "updateDomainWithClientVars",
    value: function updateDomainWithClientVars() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var updaterClientVars = function updaterClientVars() {
          try {
            if (window.__DISALBE_AUTO_UPDATE_CLIENT_VARS__ === true) {
              _this4.listen('updateDomainWithClientVars', function () {
                _this4.domainUpdater.updateDomainWithClientVars(window.clientVars, false);
              });
              resolve();
              return;
            }
            if (window.clientVars !== undefined) {
              if (window.clientVars.padId) {
                _this4.domainUpdater.updateDomainWithClientVars(window.clientVars, false);
              }
              resolve();
              return;
            }
            setTimeout(updaterClientVars, 0);
          } catch (e) {
            reject(e);
          }
        };
        setTimeout(updaterClientVars, 0);
      });
    }
  }], [{
    key: "getInstance",
    value: function getInstance(scriptLoader) {
      if (ScriptLoaderAdapter.instance === undefined) {
        ScriptLoaderAdapter.instance = new ScriptLoaderAdapter(scriptLoader);
      }
      return ScriptLoaderAdapter.instance;
    }
  }]);
  return ScriptLoaderAdapter;
}(ScriptLoaderProxy);

var getDefaultScriptLoader = function getDefaultScriptLoader() {
  return window.ScriptLoader || window.SLR;
};
function patchScriptLoader() {
  var scriptLoader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultScriptLoader();
  if (scriptLoader === undefined) {
    throw new Error('window.ScriptLoader OR window.SLR is undefined, use `patchScriptLoader(scriptLoader)` to patch');
  }
  if (scriptLoader instanceof ScriptLoaderAdapter || scriptLoader.__adpater__) {
    return scriptLoader;
  }
  var scriptLoaderAdapter = ScriptLoaderAdapter.getInstance(scriptLoader);
  window.ScriptLoader = scriptLoaderAdapter;
  window.SLR = scriptLoaderAdapter;
  return scriptLoaderAdapter;
}

var FCModule = /*#__PURE__*/function () {
  function FCModule() {
    _classCallCheck(this, FCModule);
  }
  _createClass(FCModule, [{
    key: "bootstrap",
    value: function bootstrap(extensionService, scriptLoader) {
      this.extensionService = extensionService;
      this.scriptLoader = scriptLoader;
    }
  }, {
    key: "load",
    value: function load(container) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.extension) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", this.extension);
            case 2:
              _context.next = 4;
              return this.extensionService.addExtensionDescription({
                name: this.name,
                branch: this.branch,
                containerId: container.id,
                loadType: LoadType.EAGER
              });
            case 4:
              _context.next = 6;
              return this.extensionService.getExtension(this.name);
            case 6:
              this.extension = _context.sent;
              return _context.abrupt("return", this.extension);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return FCModule;
}();

export { DependentServiceCombinder, EventTarget, EventType, ExtensionConfigManager, ExtensionEvent, ExtensionManager, ExtensionService, FCModule, IDependentServiceCombinder, IExtensionConfigManager, IExtensionEvent, IExtensionManager, IExtensionService, LoadType, ScriptLoaderAdapter, createExtensionService, initInstantiationService, injectExtensionServiceToCollection, patchScriptLoader, registerExtensionService };
//# sourceMappingURL=index.js.map
